import { obtenerMensajeError } from "utils/apiErrors";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid2";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

// Componentes
import SociedadProceso from "./sociedadProceso";

// API
import ProcesosApi from "api/procesosApi";

const SociedadesProceso = ({ procesoId, identificador, setError }) => {
  const [sociedadesProceso, setSociedadesProceso] = useState([]);
  const [loading, setLoading] = useState(true);

  const cargarSociedadesProceso = async () => {
    try {
      const respPersonas = await ProcesosApi.obtenerSociedades(procesoId);
      if (respPersonas.data) {
        setSociedadesProceso(respPersonas.data);
      }
    } catch (error) {
      console.error("Error cargando las Sociedades del Proceso:", error);
      setError(obtenerMensajeError(error, "Error al cargar las Sociedades del Proceso"));
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await cargarSociedadesProceso();
      } catch (error) {
        console.error("Error cargando datos:", error);
        setError(obtenerMensajeError(error, "Error al cargar los datos"));
      } finally {
        setLoading(false);
      }
    };
    if (procesoId) {
      fetchData();
    }
  }, [procesoId]);

  if (loading) {
    return (
      <SuiBox display="flex" justifyContent="center" p={3}>
        <SuiTypography variant="button" color="text" fontWeight="regular">
          Cargando archivos de las sociedades del proceso...
        </SuiTypography>
      </SuiBox>
    );
  }

  return (
    <SuiBox>
      <Grid container spacing={3} p={1}>
        {sociedadesProceso.map((sociedad) => (
          <Grid item xs={12} md={6} key={sociedad.id || `temp-${sociedad.nombre_completo}`}>
            <SociedadProceso
              sociedad={sociedad}
              procesoId={procesoId}
              identificador={identificador}
              setError={setError}
            />
          </Grid>
        ))}
      </Grid>
    </SuiBox>
  );
};

SociedadesProceso.propTypes = {
  procesoId: PropTypes.number.isRequired,
  identificador: PropTypes.string,
  setError: PropTypes.func.isRequired,
};

export default SociedadesProceso;
